import { c as _c } from "react/compiler-runtime";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { toggleItemSelection } from "@utils/array-utils";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { InfoIcon, SelectionIcon } from "@flat-ui";
import { useMembersUtils } from "@hooks/use-member-utils";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useProjectRemoveMenuOption } from "@hooks/use-project-remove-menu-option";
/** Hook to get the menu options for the project team members in the mobile view */
export function useProjectTeamMenuOptionsMobile(t0) {
  const $ = _c(15);
  const {
    selectedProject
  } = t0;
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const {
    openProfilePage
  } = useMembersUtils();
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  let t1;
  if ($[0] !== companyId || $[1] !== selectedProject) {
    t1 = {
      companyId,
      selectedProject
    };
    $[0] = companyId;
    $[1] = selectedProject;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    projectRemoveMenuOption,
    shouldShowProjectRemove
  } = useProjectRemoveMenuOption(t1);
  let t2;
  if ($[3] !== dispatch || $[4] !== selectedRowIds) {
    t2 = {
      label: "Select member",
      Icon: SelectionIcon,
      onSelect: member => {
        const newSelectedRowIds = toggleItemSelection(selectedRowIds, member.identity);
        dispatch(setInitialFetchingItems(newSelectedRowIds));
      },
      shouldShowDividerAfter: true
    };
    $[3] = dispatch;
    $[4] = selectedRowIds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== openProfilePage) {
    t3 = member_0 => {
      openProfilePage({
        member: member_0,
        source: "user more info menu mobile"
      });
    };
    $[6] = openProfilePage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== shouldShowProjectRemove || $[9] !== t3) {
    t4 = {
      label: "Profile",
      Icon: InfoIcon,
      onSelect: t3,
      shouldShowDividerAfter: shouldShowProjectRemove
    };
    $[8] = shouldShowProjectRemove;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== projectRemoveMenuOption || $[12] !== t2 || $[13] !== t4) {
    t5 = [t2, t4, ...projectRemoveMenuOption];
    $[11] = projectRemoveMenuOption;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}